import * as React from 'react';
import { InlineText1 } from '@cian/ui-kit';

interface ITitleProps {
  title: string;
}

export function Title({ title }: ITitleProps) {
  return <InlineText1 fontWeight="bold">{title}</InlineText1>;
}
